function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import { StatusCodes } from 'http-status-codes';
import { JsogService } from 'jsog-typescript';
import { TokenUtils } from '../utils/TokenUtils';
var jsog = new JsogService();
export var Transport = /*#__PURE__*/ function() {
    "use strict";
    function Transport() {
        var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
        _class_call_check(this, Transport);
        _define_property(this, "fetch", void 0);
        _define_property(this, "onRequest", function(config) {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        config
                    ];
                });
            })();
        });
        _define_property(this, "onRequestError", function(error) {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        Promise.reject(error)
                    ];
                });
            })();
        });
        this.fetch = axios.create({
            baseURL: baseURL
        });
    }
    _create_class(Transport, [
        {
            key: "setupInterceptors",
            value: function setupInterceptors() {
                this.fetch.interceptors.request.use(this.onRequest, this.onRequestError);
            }
        },
        {
            key: "get",
            value: function get(url, classObject, config) {
                return this.fetch.get(url, Transport.transformResponseConfig(classObject, config));
            }
        },
        {
            key: "getFile",
            value: function getFile(url) {
                return this.fetch.get(url, {
                    method: 'GET',
                    responseType: 'blob'
                });
            }
        },
        {
            key: "post",
            value: function post(url, data, classObject, config) {
                return this.fetch.post(url, data, Transport.transformResponseConfig(classObject, config));
            }
        },
        {
            key: "postAsMultipart",
            value: function postAsMultipart(url, data, classObject) {
                var config = _object_spread_props(_object_spread({}, Transport.transformResponseConfig(classObject)), {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                return this.fetch.post(url, data, config);
            }
        },
        {
            key: "put",
            value: function put(url, data, classObject) {
                return this.fetch.put(url, data, Transport.transformResponseConfig(classObject));
            }
        },
        {
            key: "putAsMultipart",
            value: function putAsMultipart(url, data, classObject) {
                var config = _object_spread_props(_object_spread({}, Transport.transformResponseConfig(classObject)), {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                return this.fetch.put(url, data, config);
            }
        },
        {
            key: "patch",
            value: function patch(url, data, classObject) {
                return this.fetch.patch(url, data, Transport.transformResponseConfig(classObject));
            }
        },
        {
            key: "del",
            value: function del(url, classObject) {
                return this.fetch.delete(url, Transport.transformResponseConfig(classObject));
            }
        },
        {
            key: "setJwtToken",
            value: function setJwtToken(jwtToken) {
                if (jwtToken) {
                    this.fetch.defaults.headers.common.Authorization = Transport.createBearerAuthorization(jwtToken);
                    TokenUtils.saveJwtToken(jwtToken);
                } else {
                    delete this.fetch.defaults.headers.common.Authorization;
                    TokenUtils.removeJwtToken();
                }
            }
        },
        {
            key: "isTokenExpiredError",
            value: function isTokenExpiredError(errorResponse) {
                var isExpiredError = false;
                if (errorResponse === StatusCodes.UNAUTHORIZED) {
                    isExpiredError = TokenUtils.isTokenExpired();
                }
                return isExpiredError;
            }
        },
        {
            key: "handleResponse",
            value: function handleResponse(onFulfilled, onRejected) {
                this.fetch.interceptors.response.use(onFulfilled, onRejected);
            }
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl() {
                return this.fetch.defaults.baseURL;
            }
        }
    ], [
        {
            key: "serialize",
            value: function serialize(object) {
                return jsog.serialize(object);
            }
        },
        {
            key: "isAxiosError",
            value: function isAxiosError(error) {
                return error.isAxiosError !== undefined;
            }
        },
        {
            key: "transformResponseConfig",
            value: function transformResponseConfig(classObject, config) {
                var requestConfig;
                var transformResponse;
                var transformer = axios.defaults.transformResponse;
                if (classObject !== undefined) {
                    transformResponse = transformer.concat(function(data) {
                        return Transport.transformData(data, classObject);
                    });
                }
                if (classObject !== undefined && config !== undefined) {
                    requestConfig = _object_spread_props(_object_spread({}, config), {
                        transformResponse: transformResponse
                    });
                } else if (classObject !== undefined) {
                    requestConfig = {
                        transformResponse: transformResponse
                    };
                } else if (config !== undefined) {
                    requestConfig = config;
                }
                return requestConfig;
            }
        },
        {
            key: "transformData",
            value: function transformData(data, classObject) {
                var result = jsog.deserialize(data, classObject);
                if (Array.isArray(result)) {
                    return result;
                }
                return result;
            }
        },
        {
            key: "createBearerAuthorization",
            value: function createBearerAuthorization(token) {
                return "Bearer ".concat(token);
            }
        }
    ]);
    return Transport;
}();
